"use client"

import { HeroCarouselSlideDto } from "api"
import {
  HeroBadge,
  HeroBadgeRow,
  HeroContent,
  HeroDescription,
  HeroEyebrow,
  HeroTitle,
} from "./hero.styled"

type Props = { slide: HeroCarouselSlideDto }

// Badge and eyebrow rows are always rendered (empty when the slide omits them)
// so their reserved height keeps the title's position fixed across slides.
const HeroSlideContent = ({ slide }: Props) => (
  <HeroContent>
    <HeroBadgeRow $hasBothText={!!slide.eyebrowText && !!slide.badgeText}>
      {slide.badgeText && <HeroBadge>{slide.badgeText}</HeroBadge>}
      <HeroEyebrow dir="auto">{slide.eyebrowText}</HeroEyebrow>
    </HeroBadgeRow>
    <HeroTitle dir="auto">
      {slide.titleLine1 && (
        <>
          {slide.titleLine1}
          <br />
        </>
      )}
      {slide.titleLine2}
    </HeroTitle>
    {slide.description && (
      <HeroDescription dir="auto">{slide.description}</HeroDescription>
    )}
  </HeroContent>
)

export default HeroSlideContent
